
/* ============================== src/utils/fileValidation.js ============================== */
/**
 * Фронтовая валидация вложений. Зеркало бэкенда (domain/file-logic.ts):
 * denylist расширений + denylist MIME + лимит размера. Фронт не читает
 * байты (security-граница — на сервере), это UX-фильтр. Модуль синхронен
 * с backend/utils/constants.js и utils/constants.js.
 */
import {
  FILE_LIMITS,
  FILE_MESSAGES,
  DENIED_EXTENSIONS,
  DENIED_MIME_TYPES,
  TEXT_SAFE_EXTENSIONS,
  mb,
} from "./constants";

function lastExtension(lowerName) {
  const idx = lowerName.lastIndexOf(".");
  if (idx <= 0 || idx === lowerName.length - 1) return "";
  return lowerName.slice(idx);
}

export function validateAttachment(file) {
  if (!file) {
    return { ok: false, code: "NO_FILE", reason: "Файл не выбран" };
  }

  if (file.size > FILE_LIMITS.attachment) {
    return {
      ok: false,
      code: "FILE_TOO_LARGE",
      reason: `Файл слишком большой (максимум ${mb(FILE_LIMITS.attachment)})`,
    };
  }

  const lowerName = String(file.name || "").toLowerCase();
  const ext1 = lastExtension(lowerName);
  if (ext1 && DENIED_EXTENSIONS.has(ext1)) {
    return {
      ok: false,
      code: "FORBIDDEN_FILE_TYPE",
      reason: FILE_MESSAGES.fileTypeForbidden,
    };
  }
  const ext2 = lastExtension(
    lowerName.slice(0, lowerName.length - ext1.length),
  );
  if (ext2 && DENIED_EXTENSIONS.has(ext2)) {
    return {
      ok: false,
      code: "FORBIDDEN_FILE_TYPE",
      reason: FILE_MESSAGES.fileTypeForbidden,
    };
  }

  if (file.type && DENIED_MIME_TYPES.has(file.type)) {
    return {
      ok: false,
      code: "FORBIDDEN_FILE_TYPE",
      reason: FILE_MESSAGES.fileTypeForbidden,
    };
  }

  if (!file.type && !TEXT_SAFE_EXTENSIONS.has(ext1)) {
    return {
      ok: false,
      code: "FILE_TYPE_UNDETERMINED",
      reason: FILE_MESSAGES.fileTypeUndetermined,
    };
  }

  return { ok: true };
}
